import React, { Component } from "react";
import HeaderNav from "./common/HeaderNav";
import "./styles/Number.css";
import "./styles/Cart.css";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { Button } from "@mui/material";
import apiCall, { guestSessionManager } from "../utils/apiCall";
import { Table } from "../component/common/Table";
import { connect } from "react-redux";
import { cartInfo } from "./common/redux/actions";
import queryString from "query-string";
import { toast } from "react-toastify";

let mountLimit = 1;

const columns = [
  { id: "number", label: "Number", minWidth: "21.7vw" },
  { id: "discountedPrice", label: "Price", minWidth: "21.7vw" },
  { id: "status", label: "Status", minWidth: "21.7vw" },
  { id: "operationDelete", label: "Remove", minWidth: "14.9vw" },
];

class Cart extends Component {
  state = {
    cartData: [],
    totalSize: 0,
    rowsPerPage: 20,
    filterData: {},
    getCartLimit: 20,
    allowCheckout: false,
  };

  async componentDidMount(commands = {}) {
    if (mountLimit == 1) {
      mountLimit++;
      try {
        let addToCart = false;
        let addToCartPayload = {
          userId: this.props.state.activeUser.isUserVerified
            ? this.props.state.activeUser.currentUser.id
            : null,
        };
        let numberIdToAdd = null;
        if (window.location.search && !commands.deleteFromCart) {
          let queryParams = queryString.parse(window.location.search);
          addToCart = queryParams.addtoCart == "true" ? true : false;
          numberIdToAdd = queryParams.numberId;
          addToCartPayload["numberId"] = numberIdToAdd;
        } else if (
          this.props.state.cartInfo &&
          Object.keys(this.props.state.cartInfo).length > 0
        ) {
          let cartDetails = this.props.state.cartInfo.cartDetails;
          addToCart = cartDetails.id ? true : false;
          numberIdToAdd = cartDetails.id;
          addToCartPayload["numberId"] = numberIdToAdd;
        }

        // Always fetch cart first
        const { result } = await apiCall(
          "REACT_APP_GET_CART",
          "POST",
          {
            limit: this.state.getCartLimit || 20,
            skip: 0,
            getIdFromUserInfo: true,
          },
          false
        );

        // Check for duplicate before adding
        let alreadyInCart = false;
        if (addToCart && numberIdToAdd && result && result["success"] && result["status"]) {
          alreadyInCart = result.status.some(
            (item) => String(item.numberId) === String(numberIdToAdd)
          );
        }
        if (addToCart && numberIdToAdd && !alreadyInCart) {
          await apiCall("REACT_APP_ADD_TO_CART", "POST", addToCartPayload);
          toast.success("Item added to cart");
        } else if (addToCart && numberIdToAdd && alreadyInCart) {
          toast.info("Item is already in your cart");
        }
        // Remove addtoCart and numberId from URL
        if (addToCart && numberIdToAdd) {
          const url = new URL(window.location);
          url.searchParams.delete("addtoCart");
          url.searchParams.delete("numberId");
          window.history.replaceState({}, document.title, url.pathname + url.search);
        }

        // Now update cartData state
        const { result: cartResult } = await apiCall(
          "REACT_APP_GET_CART",
          "POST",
          {
            limit: this.state.getCartLimit || 20,
            skip: 0,
            getIdFromUserInfo: true,
          },
          false
        );

        window.addEventListener("beforeunload", this.handleGuestCartCleanup);

        if (cartResult && cartResult["success"] && cartResult["status"]) {
          let modifyData = await this.modifyApiData(cartResult.status);
          let allowCheckout = true;
          modifyData.forEach((data) => {
            if (data.status !== "Ready to port") {
              allowCheckout = false;
            }
          });
          this.setState({
            cartData: modifyData,
            totalSize: cartResult.totalSize,
            allowCheckout: allowCheckout,
          });
        } else {
          this.setState({ cartData: [], totalSize: 0, allowCheckout: false });
        }

        this.props.cartInfo({});
      } catch (error) {
        console.log("Home componentDidMount Error ::", error);
      }
      setTimeout(() => {
        mountLimit = 1;
      }, 500);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleGuestCartCleanup);
  }

  handleGuestCartCleanup = async () => {
    // Only clear guest session if user is actually leaving the site
    // Don't clear on page reload or navigation within the app
    const guestSession = localStorage.getItem("guestSessionId");
    if (guestSession && this.state.cartData.length === 0) {
      try {
        // Only remove from cart if cart is empty
        const { result } = await apiCall("REACT_APP_REMOVE_FROM_CART", "POST", {
          guestSession,
        });
        
        // Don't clear the session ID here - let the session manager handle it
        // This prevents the session from being lost on page reloads
        if (result && result["success"] && result["status"]) {
          console.log("Guest cart cleaned up successfully");
        }
      } catch (error) {
        console.error("Error clearing guest cart:", error);
      }
    }
  };

  async modifyApiData(rawDataArray) {
    return await rawDataArray.map((data) => {
      data.createdAt = new Date(data.createdAt).toLocaleString();
      data.updatedAt = new Date(data.updatedAt).toLocaleString();

      if (data.status) {
        data.status = data.status == 2 ? "Ready to port" : "Sold";
      }

      // calculate discounted price if discount is available
      if (data.discount && data.discount > 0) {
        data.discountedPrice = data.price - (data.price * data.discount) / 100;
      } else {
        data.discountedPrice = data.price;
      }

      return data;
    });
  }

  handleChangePage = async (chnagedPage, rowsPerPage) => {
    let filterData = this.state.filterData;
    let skippedEmptyArrayOfObj = [];
    Object.keys(filterData).forEach((data) => {
      if (
        filterData[data] == [] ||
        filterData[data] == {} ||
        filterData[data] == ""
      ) {
        delete filterData[data];
      }
    });
    filterData["skip"] = chnagedPage * rowsPerPage || 0;
    filterData["limit"] = rowsPerPage || 20;
    for (let i = 0; i < filterData["skip"]; i++) {
      skippedEmptyArrayOfObj.push({});
    }
    const { result } = await apiCall(
      "REACT_APP_GET_NUMBERS",
      "POST",
      filterData
    );
    if (result && result["success"] && result["status"]) {
      let modifyData = await this.modifyApiData(result.status);
      this.setState({
        numbersData: [...skippedEmptyArrayOfObj, ...modifyData],
        rowsPerPage: rowsPerPage,
        totalSize: await result.totalSize,
      });
      return true;
    }
    return false;
  };

  deleteFromCart = async (data) => {
    try {
      if (!data || !data.id) {
        return;
      }
      const { result } = await apiCall("REACT_APP_REMOVE_FROM_CART", "POST", {
        cartId: data.id,
      });
      if (result && result["success"] && result["status"]) {
        toast.success(result.msg);
      }
      this.componentDidMount({ deleteFromCart: true });
    } catch (error) {
      console.log("deleteFromCart Error", error);
    }
  };

  handleChange = async (event, state) => {
    let filterData = this.state.filterData;
    filterData[state] = event.target.value;
    this.setState({ filterData });
  };

  render() {
    const handleCheckoutClickEvents = (event) => {
      if (!this.state.allowCheckout) {
        toast.error("remove sold numbers from cart to checkout");
      }
    };

    return (
      <React.Fragment>
        <div id="mainNumbersContainer">
          {/* render Header Nav Bar */}
          <HeaderNav activeTabName="cart" cartCount={this.state.totalSize} />

          <div id="subMainContainer" style={{ flexDirection: "column" }}>
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                overflow: "hidden",
                marginTop: "45px",
                marginBottom: "45px",
              }}
            >
              {/* Background Image */}
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>

              {/* Gradient Overlay */}
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  background: "#000040",
                }}
              ></div>
              {/* Red circular accent */}
              <div
                style={{
                  position: "absolute",
                  width: "300px",
                  height: "300px",
                  backgroundColor: "rgba(255, 0, 0, 0.8)",
                  borderRadius: "50%",
                  top: "-150px",
                  right: "-100px",
                  zIndex: 1,
                }}
              ></div>

              {/* Second red circular accent */}
              <div
                style={{
                  position: "absolute",
                  width: "150px",
                  height: "150px",
                  backgroundColor: "rgba(255, 0, 0, 0.8)",
                  borderRadius: "50%",
                  bottom: "-70px",
                  left: "50px",
                  zIndex: 1,
                }}
              ></div>

              {/* Decorative dots */}
              <div
                style={{
                  position: "absolute",
                  top: "20px",
                  left: "20px",
                  display: "flex",
                  gap: "5px",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                ></div>
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                ></div>
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                ></div>
              </div>

              {/* Decorative triangle */}
              <div
                style={{
                  position: "absolute",
                  bottom: "15px",
                  right: "60px",
                  width: 0,
                  height: 0,
                  borderLeft: "15px solid transparent",
                  borderRight: "15px solid transparent",
                  borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
                  transform: "rotate(45deg)",
                }}
              ></div>

              {/* Content Container */}
              <div
                style={{
                  position: "relative",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0 20px",
                  zIndex: "2",
                }}
              >
                <h1
                  style={{
                    color: "white",
                    fontSize: "42px",
                    fontWeight: "800",
                    marginBottom: "16px",
                    textAlign: "center",
                    textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
                  }}
                >
                  Cart Details
                </h1>

                <p
                  style={{
                    color: "white",
                    fontSize: "18px",
                    fontWeight: "400",
                    maxWidth: "700px",
                    textAlign: "center",
                    textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
                  }}
                >
                  Checkout your numbers here.
                </p>

                {/* Decorative Line */}
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    background:
                      "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
                    marginTop: "20px",
                    borderRadius: "2px",
                  }}
                ></div>
              </div>
            </div>
            {/* render numbers container with conditions */}
            <div id="CartSubContainer">
              <div className="cartContentArea">
                <div className="cartTable">
                  <Table
                    maxHeight={"fit-content"}
                    columns={columns || []}
                    dataValues={this.state.cartData || []}
                    totalSize={this.state.totalSize || 0}
                    filterHeight={0}
                    rowsPerPage={this.state.rowsPerPage}
                    handleChangePage={this.handleChangePage}
                    showPriceTotal={true}
                    deleteEntry={this.deleteFromCart}
                  />
                </div>
                <div className="cartFooter">
                  <Link to={"/numbers"} style={{ textDecoration: "none" }}>
                    <Button id="cartFooterButton" variant="contained">
                      Add More Numbers
                    </Button>
                  </Link>
                  <Link
                    to={this.state.allowCheckout ? "/checkout" : ""}
                    style={{ textDecoration: "none" }}
                  >
                    <Button
                      sx={{ opacity: this.state.allowCheckout ? "1" : "0.4" }}
                      id="cartFooterButton"
                      onClick={(e) => {
                        handleCheckoutClickEvents(e);
                      }}
                      variant="contained"
                    >
                      Checkout
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, { cartInfo })(Cart);
